export default __webpack_public_path__ + "static/media/head-pink.f08154ff.png";